/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compare_Event_Groups_Copy_Event_B_To_A_TitleInputs */



/**
* | output |
* | --- |
* | "Copy event from Group B to Group A" |
*
* @param {Compare_Event_Groups_Copy_Event_B_To_A_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const compare_event_groups_copy_event_b_to_a_title = /** @type {((inputs?: Compare_Event_Groups_Copy_Event_B_To_A_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compare_Event_Groups_Copy_Event_B_To_A_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Copier l'événement du groupe B vers le groupe A")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ereignis von Gruppe B nach Gruppe A kopieren")
	if (locale === "it") return /** @type {LocalizedString} */ ("Copia l'evento dal Gruppo B al Gruppo A")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Копирование события из группы B в группу A")
	if (locale === "es") return /** @type {LocalizedString} */ ("Copiar evento del Grupo B al Grupo A")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("将 B 组的事件复制到 A 组")
	if (locale === "ja") return /** @type {LocalizedString} */ ("グループBからグループAにイベントをコピー")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ग्रुप B से ग्रुप A में इवेंट कॉपी करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Copiar evento do Grupo B para o Grupo A")
	return /** @type {LocalizedString} */ ("Copy event from Group B to Group A")
});